import axios from 'axios'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
import { Toast } from 'vant'
import { getEncrypt, getDecrypt } from './encryption';
import store from '@/store'
import Storage from './storage'
import fun from './fun.js'

import { baseUrl, h5BaseUrl } from './urlConfig'

console.log('1---', process.env.VUE_APP_ENV || process.env.NODE_ENV)
// console.log('2---',process.env.VUE_APP_URLENV)
console.log('3---', baseUrl)
store.commit('app/SET_BASE_URL', h5BaseUrl)
// 点对点调试
if (!Storage.get('olympus-ribbon-meta-route-tag')) {
    Storage.set('olympus-ribbon-meta-route-tag', '')
}
const service = axios.create({
    baseURL: baseUrl, // url = base url + request url
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000, // request timeout
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        'olympus-ribbon-meta-route-tag': Storage.get('olympus-ribbon-meta-route-tag')
    }
})

// request interceptor
service.interceptors.request.use(
    async (config) => {
        if (!config.hideLoading) {
            Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...',
            });
        }
        // 图片上传
        if (config.headers['Content-Type'] == 'multipart/form-data') {
            return config
        }

        if (config.noIntercept) {		//不拦截请求
            config.data = getEncrypt(config, config.noEncrypt);
            return config
        } else {
            return new Promise(async(resolve) => {
                fun.disposeSession().then(res => {
                    config.data = getEncrypt(config);
                    resolve(config)
                })
            })
        }

    },
    error => {
        // do something with request error
        console.log(error) // for debug
        return Promise.reject(error)
    }
)
service.interceptors.response.use(response => {
    if (!response.config.hideLoading) {
        Toast.clear()
    }
    // console.log(response)
    return getDecrypt(response)

}, error => {
    console.log('TCL: error', error)
    if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
        Toast('请求超时')
    }
    return Promise.reject(error)
})

// response interceptor

// service.interceptors.response.use(
//     /**
//      * If you want to get http information such as headers or status
//      * Please return  response => response
//     */

//     /**
//      * Determine the request status by custom code
//      * Here is just an example
//      * You can also judge the status by HTTP Status Code
//      */
//     response => {
//         const res = response.data
//         // if the custom code is not 20000, it is judged as an error.
//         if (res.code !== 20000) {
//             let newObj = JSON.parse(AES.decrypt(response.data));
//             if (newObj.res == 1000) {
//                 if(newObj.msg.resultCode==1002){
//                     // MessageBox.confirm('用户登录状态过期,请重新登录', '提示', {
//                     //     confirmButtonText: '确定',
//                     //     showCancelButton:false,
//                     //     showClose:false,
//                     //     closeOnClickModal:false,
//                     //     type: 'warning'
//                     // }).then(() => {
//                     //     backLoginFlag = true
//                     //     router.replace('/')
//                     // })
//                     return newObj.msg
//                 }else{
//                     return newObj.msg
//                 }
//             }

//             // Message({
//             //     message: res.message || 'Error',
//             //     type: 'error',
//             //     duration: 5 * 1000
//             // })

//             // // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
//             // if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
//             //     // to re-login
//             //     MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
//             //         confirmButtonText: 'Re-Login',
//             //         cancelButtonText: 'Cancel',
//             //         type: 'warning'
//             //     }).then(() => {
//             //         store.dispatch('user/resetToken').then(() => {
//             //             location.reload()
//             //         })
//             //     })
//             // }
//             // return Promise.reject(new Error(res.message || 'Error'))
//         } else {

//             return res
//         }
//     },
//     error => {
//         console.log('err' + error) // for debug
//         Message({
//             message: error.message,
//             type: 'error',
//             duration: 5 * 1000
//         })
//         return Promise.reject(error)
//     }
// )

export default service
